import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  videoGalleryContainer: {
    marginBottom: 84,
  },
  mainVideoContainer: {
    display: "inline-block",
    marginRight: 20,
    [theme.breakpoints.up("md")]: {
      width: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  thumbnailColumn: {
    [theme.breakpoints.up("md")]: {
      width: "25%",
      display: "inline-block",
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      gap: 15,
      width: "100%",
      overflow: "scroll",
      whiteSpace: "nowrap",
    },
    verticalAlign: "top",
  },
  mainVideo: {
    marginBottom: 10,
  },
  videoCardTitle: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    margin: "10px 0px",
  },
  videoCardCaption: {
    color: theme.palette.text.secondary,
  },
}));
